{
	"admin": {
		"document_title": "{{productName}} · Administration",
		"document_title_unbranded": "Administration",
		"nav_label": "Administration"
	},
	"details": {
		"access": {
			"label": "Who has access",
			"more_one": "and one more person",
			"more_other": "and {{count}} more people"
		},
		"actions": {
			"manage_access": "Manage access"
		},
		"announce": {
			"closed": "Details panel closed",
			"opened": "Details panel opened"
		},
		"dates": {
			"created": "Uploaded",
			"created_folder": "Created",
			"modified": "Last change",
			"original": "Original date",
			"original_hint": "The date the file already had on the device it was uploaded from."
		},
		"empty": {
			"description": "Pick a file or a folder in the list to see its details here.",
			"title": "Nothing selected"
		},
		"error": {
			"description": "It may have been moved, deleted, or no longer shared with you.",
			"title": "This item could not be read"
		},
		"info": {
			"contents": "Contents",
			"label": "Information",
			"owner": "Owner",
			"size": "Size",
			"type": "Type"
		},
		"kind": {
			"file": "File",
			"folder": "Folder"
		},
		"menu": "File information",
		"open": "Info",
		"path": {
			"label": "Path"
		},
		"received": {
			"label": "Source",
			"value": "Received through an upload link from {{name}}"
		},
		"title": "Details",
		"toggle": "Details",
		"trashed": {
			"deleted": "No further details are available.",
			"deleted_at": "Sent to the bin on {{date}}.",
			"deleted_by": "Deleted by {{name}} on {{date}}.",
			"restorable_by": "{{name}} can restore it from their bin.",
			"restorable_by_unknown": "Somebody with access to it can restore it from their bin.",
			"restore": {
				"action": "Restore",
				"error": "This item could not be restored. Try again.",
				"restoring": "Restoring…"
			},
			"title": "This item was sent to the bin"
		},
		"type": {
			"archive": "Archive",
			"audio": "Audio",
			"document": "Document",
			"image": "Image",
			"presentation": "Presentation",
			"spreadsheet": "Spreadsheet",
			"video": "Video"
		},
		"versions": {
			"current": "Current",
			"delete": {
				"action": "Delete version",
				"confirm": "Delete",
				"deleting": "Deleting…",
				"description": "The content of this version will be deleted for good: it can no longer be opened, downloaded or restored. The version stays in the history, marked as deleted.",
				"error": "This version could not be deleted. Try again.",
				"success": "Version {{versionNumber}} deleted.",
				"title": "Delete version {{versionNumber}}?"
			},
			"deleted": "Version deleted",
			"deleted_label": "Version {{versionNumber}}, deleted",
			"empty": {
				"description": "Earlier versions are kept from this point on."
			},
			"error": "This file's versions could not be read.",
			"label": "Versions",
			"number": "Version {{versionNumber}}",
			"open": "Preview version {{versionNumber}}",
			"preview_title": "{{name}} (version {{versionNumber}})",
			"restore": {
				"action": "Restore this version",
				"confirm": "Restore",
				"conflict": {
					"changed_by": "Changed by {{name}} on {{date}}.",
					"reload": "Reload the history",
					"title": "Something changed in the meantime"
				},
				"description": "A new version will be created with this content. The existing versions stay in the history.",
				"error": "This version could not be restored. Try again.",
				"restoring": "Restoring…",
				"success": "Created version {{toVersionNumber}} from the content of version {{fromVersionNumber}}.",
				"title": "Restore version {{versionNumber}}?"
			},
			"row_menu": "More actions on version {{versionNumber}}",
			"show_more": "Show more",
			"today": "Today",
			"via_request": "{{name}} · via upload link",
			"when": "{{day}}, {{time}}",
			"yesterday": "Yesterday"
		}
	},
	"directory_feed": {
		"interrupted": "Automatic updates are interrupted. Reconnecting.",
		"unavailable": "Automatic updates are unavailable. Reload the page to get them back.",
		"unavailable_neutral": "Automatic updates are unavailable."
	},
	"favorites": {
		"empty": {
			"description": "Add files and folders from the «Add to favorites» menu and they will show up here.",
			"title": "No favorites yet"
		},
		"error": {
			"description": "Try again: nothing has changed.",
			"title": "We couldn't load your favorites"
		},
		"offline": {
			"description": "You seem to be offline, so we can't load your favorites. We'll try again as soon as the connection is back."
		},
		"title": "Favorites"
	},
	"files": {
		"breadcrumb": {
			"show_hidden": "Show the folders in between"
		},
		"copy": {
			"clipboard": {
				"copied_one": "Item copied to clipboard",
				"copied_other": "{{count}} items copied to clipboard",
				"folders_refused": "Folders can’t be copied",
				"links_failed": "Couldn’t copy the links to the clipboard"
			},
			"copying": "Copying…",
			"created": "Copy created: {{name}}",
			"created_in_personal_one": "Copy created in “My files”",
			"created_in_personal_other": "{{count}} copies created in “My files”",
			"created_many_one": "{{count}} copy created",
			"created_many_other": "{{count}} copies created",
			"go_to_personal": "Open",
			"open": "Make a copy",
			"refusal": {
				"conflict": "Couldn’t copy: the file is uploading or just changed. Try again shortly",
				"depth": "Couldn’t copy: the folder is nested too deep",
				"folder": "Folders can’t be copied",
				"in_progress": "A copy is already in progress. Wait for it to finish, then try again",
				"invalid_name": "Couldn’t copy: the file name isn’t valid in this folder",
				"not_found": "Couldn’t copy: the file or folder is no longer available",
				"path_too_long": "Couldn’t copy: the path is too long. Choose a shallower folder",
				"quota": "Couldn’t copy: not enough storage space",
				"read_only": "Couldn’t copy: you don’t have permission for this folder",
				"too_large": "5 GB limit exceeded. Select fewer files and try again",
				"unknown": "Couldn’t complete the copy. Try again"
			},
			"refused_one": "Couldn’t copy {{count}} file",
			"refused_other": "Couldn’t copy {{count}} files"
		},
		"delete": {
			"confirm": "Move to bin",
			"confirm_description_one": "“{{name}}” will be moved to the bin.",
			"confirm_description_other": "{{count}} items will be moved to the bin.",
			"confirm_title": "Move to bin?",
			"deleting": "Deleting…",
			"done_one": "Item moved to the bin.",
			"done_other": "{{count}} items moved to the bin.",
			"menu": "Move to bin",
			"refusal": {
				"insufficient_role": "You cannot delete this.",
				"unknown": "This could not be deleted. Try again.",
				"upload_in_progress": "This is still being uploaded. Try again once it has finished."
			},
			"refusal_line": "“{{name}}”: {{reason}}",
			"refused_one": "One item could not be deleted.",
			"refused_other": "{{count}} items could not be deleted.",
			"undo": "Undo",
			"undo_error": "Could not undo. Open the bin to restore it by hand.",
			"undoing": "Restoring…"
		},
		"download": {
			"actions": {
				"cancel": "Cancel the download",
				"retry": "Try again"
			},
			"detail": {
				"done": "Completed · {{size}}",
				"handed_over": "The browser is downloading it · {{size}}",
				"missing_one": "Completed · {{count}} file not downloaded",
				"missing_other": "Completed · {{count}} files not downloaded",
				"size_progress": "{{received}} of {{total}}",
				"size_progress_percent": "{{percent}}% · {{received}} of {{total}}",
				"zip_done_one": "Completed · {{count}} file · {{size}}",
				"zip_done_other": "Completed · {{count}} files · {{size}}"
			},
			"failure": {
				"memory": "This download is too large for the browser. Use the desktop app.",
				"none": "These files no longer exist."
			},
			"group": "Downloads",
			"missing": {
				"hide": "Hide",
				"show": "See which"
			},
			"nothing": "Nothing to download",
			"open": "Download",
			"refusal": {
				"not_found": "The file you’re trying to download is no longer available.",
				"unknown": "Download failed",
				"unknown_retry": "Download failed, try again"
			},
			"state": {
				"cancelled": "Cancelled",
				"failed": "Failed",
				"paused": "Paused",
				"queued": "Waiting"
			},
			"too_large": {
				"close": "Close",
				"description": "This selection is over the browser’s limit (max {{limit}}). Use the desktop app to download all {{size}}.",
				"description_many": "This selection has too many files for the browser. Use the desktop app to download all of it.",
				"description_selection": "You selected {{count}} items, but the browser’s limit is {{max}}. Use the desktop app to download everything.",
				"get_client": "Get the desktop app",
				"ok": "Got it",
				"title": "Too large for the browser"
			}
		},
		"drag": {
			"items_one": "{{count}} item",
			"items_other": "{{count}} items"
		},
		"empty": {
			"description_writable": "Drag files here to upload them, or use the New button.",
			"title": "This folder is empty"
		},
		"error": {
			"description": "Try again, or reload the page.",
			"title": "This folder could not be loaded"
		},
		"favorites": {
			"add": {
				"done_one": "Added to favorites.",
				"done_other": "{{count}} items added to favorites.",
				"error": "Could not add to favorites. Try again.",
				"loading_one": "Adding to favorites…",
				"loading_other": "Adding {{count}} items to favorites…",
				"menu": "Add to favorites",
				"partial": "{{done}} of {{total}} added to favorites. The rest can no longer be reached.",
				"skipped": "These items can no longer be reached, so they were not added."
			},
			"remove": {
				"done_one": "Removed from favorites.",
				"done_other": "{{count}} items removed from favorites.",
				"error": "Could not remove from favorites. Try again.",
				"loading_one": "Removing from favorites…",
				"loading_other": "Removing {{count}} items from favorites…",
				"menu": "Remove from favorites",
				"partial": "{{done}} of {{total}} removed from favorites. The rest can no longer be reached.",
				"skipped": "These items can no longer be reached, so they were not changed."
			},
			"tooltip": "Favorites"
		},
		"filters": {
			"category": {
				"archive": "Archives",
				"audio": "Audio",
				"document": "Documents",
				"folder": "Folders",
				"image": "Images",
				"label": "Type",
				"other": "Other",
				"presentation": "Presentations",
				"spreadsheet": "Spreadsheets",
				"video": "Videos"
			},
			"clear_all": "Clear filters",
			"empty": {
				"description": "The filters look at the items in this folder only, not at the ones inside its subfolders: what you are after may be a level further down.",
				"description_favorites": "The filters only look at the favorites listed here, not at what they contain.",
				"description_search": "The filters narrow the results found for this term: try removing one, or searching for something else.",
				"description_shared": "The filters look at the items shared with you listed here, not at what they contain.",
				"description_trash": "The filters look at the items in the bin listed here, not at what a deleted folder contains.",
				"title": "Nothing matches the filters"
			},
			"people": {
				"empty": "Nobody by that name.",
				"label": "People",
				"search": "Search for a person",
				"unnamed": "Name unavailable"
			},
			"unreadable": "Part of the address could not be read ({{names}}): the listing is open without it."
		},
		"item": {
			"children_one": "{{count}} item",
			"children_other": "{{count}} items",
			"open_folder": "Open the folder {{name}}",
			"open_menu": "More actions on {{name}}",
			"shared": "Shared",
			"thumbnail_alt": "Preview of {{name}}"
		},
		"listing": {
			"actions": "Actions",
			"modified": "Modified",
			"name": "Name",
			"no_value": "Not available",
			"owner": "Owner",
			"owner_you": "You",
			"path": "Path",
			"path_here": "In this folder",
			"shared_by": "Shared by",
			"size": "Size",
			"sort_by": "Sort by {{column}}",
			"today": "today",
			"yesterday": "yesterday"
		},
		"move": {
			"confirm": "Move here",
			"exposes_one": "Moving it here lets one more person see it.",
			"exposes_other": "Moving it here lets {{count}} more people see it.",
			"exposes_title": "The destination is shared",
			"exposes_up_to_one": "Moving these here lets at most one more person see them.",
			"exposes_up_to_other": "Moving these here lets at most {{count}} more people see them.",
			"into": "Into “{{name}}”",
			"keep_both_one": "Keep both",
			"keep_both_other": "Keep both ({{count}} items)",
			"moved_one": "Item moved.",
			"moved_other": "{{count}} items moved.",
			"moving": "Moving…",
			"names_more": "{{names}} and {{count}} more",
			"no_subfolders": "No subfolders",
			"no_subfolders_hint": "You can move the items straight here, or create a folder.",
			"open": "Move",
			"opens_to_org_one": "After the move, anyone in {{org}} who has the link will be able to see it.",
			"opens_to_org_other": "After the move, anyone in {{org}} who has the link will be able to see them.",
			"opens_to_org_title": "The destination is open to the whole organization",
			"path": "Path of the folder being shown",
			"preserves_detail": "The grants stay in the sharing panel and can be removed from there. Anybody who was an owner by inheritance becomes an editor, and a sharing panel already open on this item will conflict when it is saved.",
			"preserves_one": "One person reaches this item only through the folder it is leaving. The move writes them a direct grant, so they do not lose it.",
			"preserves_other": "{{count}} people reach this item only through the folder it is leaving. The move writes them a direct grant, so they do not lose it.",
			"preserves_title": "Everyone with access keeps it",
			"preserves_up_to_one": "At most one person reaches these items only through the folder they are leaving. The move writes them a direct grant, so they do not lose them.",
			"preserves_up_to_other": "At most {{count}} people reach these items only through the folder they are leaving. The move writes them a direct grant, so they do not lose them.",
			"refusal": {
				"cycle": "A folder cannot be moved inside itself.",
				"name_taken_suggested": "The destination already has something with this name. “{{name}}” is free.",
				"unknown": "This could not be moved. Try again."
			},
			"refused_one": "Could not be moved.",
			"refused_other": "{{count}} items could not be moved.",
			"title_one": "Move “{{name}}” to…",
			"title_other": "Move {{count}} items to…",
			"unavailable_moving": "“{{name}}”: you are moving this",
			"unavailable_role": "“{{name}}”: you cannot add anything to this folder",
			"unnamed": "this folder"
		},
		"name": {
			"already_there": "«{{name}}» was already here: nothing was created, and this is the folder that was.",
			"cancel": "Cancel",
			"create_confirm": "Create",
			"created": "Folder “{{name}}” created.",
			"created_in": "It will be created in “{{name}}”",
			"creating": "Creating…",
			"label": "Name",
			"length": "{{length}} of {{max}} characters",
			"new": "New",
			"new_folder": "New folder",
			"new_folder_default": "Untitled folder",
			"rename": "Rename",
			"renamed": "Renamed to “{{name}}”.",
			"renaming": "Renaming…"
		},
		"name_refusal": {
			"insufficient_role": "You do not have permission to write in this folder.",
			"invalid_name": {
				"empty": "The name cannot be empty.",
				"illegal_character": "The name contains a character that cannot be used: / \\ : * ? \" < > | or other disallowed characters",
				"relative_path": "“.” and “..” are not names: they point at a path.",
				"reserved_name": "Windows reserves this name, so it cannot be used. Pick another one.",
				"too_long": "The name is too long. Make it shorter.",
				"trailing_dot_or_space": "The name cannot end with a dot or a space.",
				"unknown": "The name does not follow the naming rules. Try another one."
			},
			"looks_identical": "The name you typed looks identical to one already here but is composed differently: this happens when the same accent is written by a Mac and by a Windows machine.",
			"max_depth_exceeded": "You have reached the maximum depth allowed. Create this folder higher up the tree.",
			"name_taken": "Something in this folder already has this name. Upper and lower case make no difference.",
			"not_found": "This folder no longer exists, or is no longer reachable.",
			"parent_not_folder": "A file cannot contain anything.",
			"parent_trashed": "The destination folder is in the bin. Restore it first.",
			"path_too_long": "The full path would become too long for desktop clients. Use a shorter name, or a folder that is less deep.",
			"personal_folder_cannot_move": "A personal folder always sits at the top of its own tree and cannot be moved.",
			"personal_folder_fixed_name": "Your personal folder is named after the language you read in, so it cannot be renamed.",
			"suggested": "A free name in this folder is “{{name}}”."
		},
		"nav_label": "My files",
		"offline": {
			"description": "It will load again once the connection is back.",
			"title": "No connection"
		},
		"open": {
			"label": "Open",
			"new_tab": "Open in a new tab",
			"reveal": "Show in folder",
			"unavailable": {
				"description": "It may have been moved, deleted or never shared with you, or the connection dropped. Go back to your files and try again.",
				"title": "This file cannot be opened"
			}
		},
		"origin": {
			"organization": "Opened to the whole organization by {{name}}",
			"shared_by": "Shared by {{name}}"
		},
		"preview": {
			"error": {
				"description": "Check the connection and try again.",
				"title": "The preview could not be loaded"
			},
			"label": "Preview of {{name}}",
			"loading": "Loading the preview…",
			"open": "Preview",
			"pdf": {
				"fit": "Fit",
				"interrupted": {
					"description": "The pages not seen yet can no longer be fetched. Reload to carry on where you were.",
					"reload": "Reload",
					"title": "The preview has expired"
				},
				"locked": {
					"description": "The preview does not open protected files. Download it to open it.",
					"title": "This PDF is password-protected"
				},
				"page": "Page {{page}} of {{pages}}",
				"pages": "Pages",
				"search": {
					"label": "Search in the document",
					"matches": "{{current}} of {{total}}",
					"next": "Next match",
					"none": "No results",
					"placeholder": "Search",
					"previous": "Previous match"
				},
				"thumbnail": "Page {{page}}",
				"unreadable": "The file may be damaged. Download it and open it in a PDF reader.",
				"zoom": "Zoom",
				"zoom_in": "Zoom in",
				"zoom_out": "Zoom out"
			},
			"refused": {
				"title": "This file cannot be previewed"
			},
			"too_large": {
				"description": "Above {{limit}} the preview is not generated, so the tab does not run out of memory. Download the file to open it.",
				"title": "Too large to preview"
			},
			"unreadable": {
				"description": "The file may be damaged, or written in a way this preview does not understand. Download it and open it in Word or PowerPoint.",
				"title": "This file could not be opened"
			},
			"unsupported": {
				"description": "Download it to open it.",
				"title": "No preview for this format"
			}
		},
		"section": {
			"files": "Files",
			"folders": "Folders"
		},
		"select": {
			"blocked_folder": "You cannot move anything out of this folder",
			"blocked_one": "{{count}} item cannot be moved",
			"blocked_other": "{{count}} items cannot be moved",
			"blocked_root": "There is no folder to move out of here",
			"clear": "Clear the selection",
			"count_one": "{{count}} item selected",
			"count_other": "{{count}} items selected",
			"delete": "Delete",
			"delete_blocked_one": "{{count}} item cannot be deleted",
			"delete_blocked_other": "{{count}} items cannot be deleted",
			"details_multiple": "You cannot show details for multiple items",
			"item": "Select {{name}}",
			"preview_multiple": "You cannot preview multiple items",
			"rename_multiple": "You cannot rename multiple items",
			"rename_role": "You cannot rename this",
			"share_multiple": "You cannot share multiple items",
			"share_role": "You cannot share this"
		},
		"sort": {
			"button": "Sort",
			"column": {
				"last_viewed": "Last viewed",
				"name": "Name",
				"size": "Size",
				"updated": "Last modified"
			},
			"direction": {
				"label": "Direction",
				"last_viewed_asc": "Least recent first",
				"last_viewed_desc": "Most recent first",
				"name_asc": "A → Z",
				"name_desc": "Z → A",
				"size_asc": "Smallest first",
				"size_desc": "Largest first",
				"updated_asc": "Oldest first",
				"updated_desc": "Newest first"
			},
			"folders_first": "Folders always on top",
			"label": "Sort by",
			"trigger": "Sort by: {{column}}, {{direction}}"
		},
		"tree_collapse": "Collapse {{name}}",
		"tree_expand": "Expand {{name}}",
		"tree_load_failed": "Could not load the folders",
		"tree_show_more": "Show more",
		"unreachable": {
			"failed": {
				"description": "The connection dropped before the file arrived. Try again in a moment.",
				"title": "We could not open the file"
			},
			"file": {
				"description": "It may have been deleted or moved, or it is not shared with you. Ask whoever sent you the link to give you access.",
				"title": "You cannot open this file"
			},
			"folder": {
				"description": "It may have been deleted or moved, or it is not shared with you. Ask whoever sent you the link to give you access.",
				"title": "You cannot open this folder"
			},
			"go_to_files": "Go to my files",
			"trashed": {
				"description": "You can restore it from the bin.",
				"title": "Moved to the bin"
			}
		},
		"upload": {
			"cancel": "Cancel upload",
			"choose": "Upload files",
			"choose_folder": "Upload folder",
			"close_confirm": {
				"both": "{{uploads}} and {{downloads}} are still in progress. If you close now the uploads stop and what was already sent is deleted; the downloads are cancelled and what was already downloaded is lost.",
				"cancel": "Keep open",
				"confirm": "Stop everything",
				"description_one": "1 transfer is still in progress. If you close now it stops and what was already sent is deleted.",
				"description_other": "{{count}} transfers are still in progress. If you close now they stop and what was already sent is deleted.",
				"downloads_one": "1 download is still in progress. If you close now it’s cancelled and what was already downloaded is lost.",
				"downloads_other": "{{count}} downloads are still in progress. If you close now they’re cancelled and what was already downloaded is lost.",
				"title": "Stop the transfers in progress?"
			},
			"done_detail": "Completed · {{size}}",
			"drop_here": "Drop your files to upload <b>here</b>",
			"drop_home": "Drop your files to upload to <b>your files</b>",
			"drop_into": "Drop your files to upload to the directory <b>{{name}}</b>",
			"folder": {
				"cancelled_one": "Cancelled · {{done}} file already uploaded stays in the folder",
				"cancelled_other": "Cancelled · {{done}} files already uploaded stay in the folder",
				"done": "Done · {{total}} files · {{size}}",
				"done_copies_one": "Done · {{total}} files · {{count}} uploaded as a copy",
				"done_copies_other": "Done · {{total}} files · {{count}} uploaded as copies",
				"done_errors_one": "{{done}} of {{total}} files uploaded · {{count}} not uploaded",
				"done_errors_other": "{{done}} of {{total}} files uploaded · {{count}} not uploaded",
				"exists": {
					"confirm": "Confirm",
					"description": "A folder named “{{name}}” already exists at this destination. What would you like to do?",
					"merge": "Upload and merge",
					"merge_hint": "The files will be added to the existing folder. For each file with the same name, we'll ask you what to do.",
					"rename": "Upload and rename",
					"rename_hint": "The folder you are uploading will be renamed.",
					"skip": "Don't upload",
					"skip_hint": "No files will be changed. The folder upload is cancelled.",
					"title": "Duplicate items"
				},
				"interrupted": "Interrupted · {{done}} of {{total}} files uploaded",
				"list": {
					"close": "Close",
					"copies_one": "Saved under another name · {{count}}",
					"copies_other": "Saved under another name · {{count}}",
					"copy_of": "“{{name}}” already existed",
					"failed_one": "Not uploaded · {{count}}",
					"failed_other": "Not uploaded · {{count}}",
					"summary": "{{done}} of {{total}} files uploaded.",
					"title": "“{{name}}”"
				},
				"nothing": "The folder is empty.",
				"offline": "Waiting for a connection · {{done}} of {{total}} files",
				"preparing": "Preparing · {{count}} files",
				"progress": "{{percent}}% · {{done}} of {{total}} files · {{sent}} of {{size}}",
				"reselect": "Pick the folder again",
				"reselect_mismatch": "That’s a different folder. Pick “{{name}}”.",
				"resume": "Resume",
				"see_which": "See which",
				"too_large": {
					"description": "“{{name}}” has more than {{max}} files, the most the browser can upload at once. Use the desktop app, or upload the subfolders one at a time.",
					"title": "This folder is too large for the browser"
				}
			},
			"folder_badge": {
				"batch_one": "{{count}} file",
				"batch_other": "{{count}} files",
				"count_one": "{{count}} file arriving",
				"count_other": "{{count}} files arriving",
				"title": "Someone's uploading to this folder"
			},
			"give_up": {
				"action": "Delete the upload",
				"cancel": "Cancel",
				"confirm": "Delete",
				"description": "What was already uploaded is deleted and the name becomes free again. Uploading the file again starts from scratch.",
				"failed": "The upload could not be deleted. It’s still unfinished and the name is still taken.",
				"title": "Delete the upload of “{{name}}”?"
			},
			"overwrite": {
				"apply_to_all_one": "Apply this option to the next duplicate",
				"apply_to_all_other": "Apply this option to the next {{count}} duplicates",
				"confirm": "Confirm",
				"description": "A file named “{{name}}” already exists at this destination. What would you like to do?",
				"pending": "Waiting for your choice.",
				"rename": "Upload and rename",
				"rename_hint": "The file you are uploading will be renamed as “{{newName}}”.",
				"skip": "Don't upload",
				"skip_hint": "No files will be changed. The new upload is skipped, and you will keep the existing version.",
				"title": "Duplicate items",
				"update": "Upload and update",
				"update_hint": "The file will be updated, keeping the version history."
			},
			"panel": {
				"add": "Add",
				"close": "Close transfers",
				"collapse": "Collapse",
				"completed": "Completed",
				"destination": "Uploading to <folder>{{name}}</folder>",
				"destination_unavailable": "Folder no longer available",
				"dismiss": "Remove from list",
				"downloaded_one": "{{count}} download completed",
				"downloaded_other": "{{count}} downloads completed",
				"downloading_one": "{{count}} download in progress…",
				"downloading_other": "{{count}} downloads in progress…",
				"downloads_count_one": "{{count}} download",
				"downloads_count_other": "{{count}} downloads",
				"expand": "Expand",
				"failed_one": "{{count}} failed",
				"failed_other": "{{count}} failed",
				"mixed_progress": "{{done}} of {{total}} uploaded · {{received}} of {{size}} downloaded",
				"paused": "Paused",
				"paused_detail": "They resume when you’re back online",
				"pending_detail": "Pick them up from the list before they expire",
				"pending_one": "{{count}} pending",
				"pending_other": "{{count}} pending",
				"progress": "{{done}} of {{total}} uploaded",
				"title": "Transfers",
				"transfers_in_progress": "{{uploads}} · {{downloads}} in progress",
				"uploaded_of": "{{uploaded}} of {{total}} files uploaded",
				"uploaded_one": "{{count}} file uploaded",
				"uploaded_other": "{{count}} files uploaded",
				"uploading_one": "{{count}} file in progress…",
				"uploading_other": "{{count}} files in progress…",
				"uploads_count_one": "{{count}} upload",
				"uploads_count_other": "{{count}} uploads"
			},
			"paused_detail": "Waiting for a connection",
			"queued_detail": "Queued · {{size}}",
			"refusal": {
				"illegal_character": "The name contains characters that aren’t allowed. Remove: / \\ : * ? \" < > |",
				"insufficient_role": "You don’t have permission to upload to this folder.",
				"not_found": "The destination folder doesn’t exist or was moved. Choose a new location.",
				"parent_trashed": "The destination folder is in the bin. Restore it to continue the upload.",
				"path_too_long": "The path is too long. Use a shorter name or a less nested folder.",
				"quota_organization": "Your organization does not have enough space for this file. Ask an administrator.",
				"quota_person": "You do not have enough space for this file. Free some by deleting files and emptying the bin.",
				"unknown": "Upload failed",
				"unknown_retry": "Upload failed, try again",
				"upload_target_deleted": "Someone deleted the file while you were uploading it.",
				"version_conflict": "Somebody replaced this file before this upload finished. Nothing here was lost, but this upload was not published.",
				"version_replaced": "Someone updated this file before you finished. Your upload was not published."
			},
			"replacing_name": "<prefix>New version of</prefix> <file>{{name}}</file>",
			"resumable_days_one": "Unfinished · expires in {{count}} day",
			"resumable_days_other": "Unfinished · expires in {{count}} days",
			"resumable_hours_one": "Unfinished · expires in {{count}} hour",
			"resumable_hours_other": "Unfinished · expires in {{count}} hours",
			"resume": {
				"action": "Resume",
				"file_changed": "The file can’t be read (it may have been changed). Select it again to continue.",
				"refusal": {
					"upload_file_mismatch": "That’s a different file. Pick the one you started with."
				}
			},
			"retry": "Try again",
			"size_progress": "{{percent}}% · {{sent}} of {{total}}",
			"state": {
				"cancelled": "Cancelled",
				"conflict": "Needs your choice",
				"done": "Completed",
				"failed": "Failed",
				"paused": "Paused",
				"queued": "Queued",
				"resumable": "Unfinished",
				"sending": "Uploading"
			}
		},
		"view": {
			"grid": "Grid layout",
			"label": "View",
			"list": "List layout"
		}
	},
	"groups": {
		"column_email": "Email",
		"column_member": "Member",
		"is_member": "You are a member",
		"member_count_one": "{{count}} member",
		"member_count_other": "{{count}} members",
		"no_members": "No members",
		"no_members_match": "No members found.",
		"visibility": {
			"private": "Private",
			"private_description": "Visible only to its members and the administrators.",
			"public": "Public",
			"public_description": "The whole organization can find the group, see its members and share files with it."
		},
		"you": "(you)"
	},
	"invite": {
		"activating": "Activating…",
		"description": "Set a password to finish activating your account.",
		"email": "Email",
		"failed": {
			"link_closed": {
				"description": "It expired or was used while this page was open. Ask whoever invited you to send a new one.",
				"title": "This invitation is no longer usable"
			},
			"organization_unavailable": {
				"description": "Try again shortly, or contact whoever invited you.",
				"title": "Your organization cannot be reached right now"
			},
			"password_rejected": {
				"description": "It does not meet your organization's rules. Choose another one: nothing has changed yet.",
				"title": "That password was refused"
			},
			"provider_unavailable": {
				"description": "Your invitation is untouched. Submit the form again in a moment.",
				"title": "We could not set your password"
			},
			"rate_limited": {
				"description": "Wait a few minutes before trying again.",
				"title": "Too many attempts"
			},
			"unavailable": {
				"description": "Something went wrong on the way. Submit the form again.",
				"title": "We could not finish the activation"
			}
		},
		"first_name": "First name",
		"handing_over": {
			"description": "Enter the password you have just chosen.",
			"signed_in": "Taking you to your workspace…",
			"title": "Taking you to sign in…"
		},
		"last_name": "Last name",
		"loading": "Checking your invitation…",
		"organization": "Organization",
		"password": "Password",
		"password_policy": {
			"rules": {
				"digits": "contains at least {{value}} digit",
				"length": "is at least {{value}} characters long",
				"lowerCase": "contains at least {{value}} lowercase letter",
				"passwordHistory": "is not one of your last {{value}} passwords",
				"specialChars": "contains at least {{value}} special character",
				"upperCase": "contains at least {{value}} capital letter"
			},
			"title": "Your organization requires a password that:"
		},
		"refused": {
			"already_used": {
				"description": "Your account is already active. Sign in with your email and the password you chose.",
				"go_to_login": "Go to sign in",
				"title": "Invitation already used"
			},
			"expired": {
				"description": "Invitations are valid for a limited time. Ask whoever invited you to send you a new one.",
				"title": "This invitation has expired"
			},
			"invalid": {
				"description": "Check that you opened the whole link from the email. If it still fails, ask whoever invited you to send you a new one.",
				"title": "This invitation link does not work"
			},
			"organization_not_ready": {
				"description": "Your invitation is valid. Try again in a few minutes.",
				"title": "Your organization is still being set up"
			},
			"organization_suspended": {
				"description": "While it is suspended, nobody can sign in. Contact whoever invited you.",
				"title": "Your organization is suspended"
			},
			"rate_limited": {
				"description": "Wait a few minutes, then open the link from the email again.",
				"title": "Too many attempts"
			},
			"unavailable": {
				"description": "Nothing about your invitation has changed. Reload the page to try again.",
				"title": "We could not check your invitation"
			}
		},
		"submit": "Set password and continue",
		"title": "You have been invited to {{organization}}"
	},
	"login": {
		"continue": "Continue",
		"description": "Enter your organization to sign in.",
		"oidc_callback_failed": "Sign-in did not complete. Try again.",
		"redirecting": "Redirecting to sign-in…",
		"request_id": "Request code: {{requestId}}",
		"slug_label": "Organization",
		"slug_placeholder": "acme",
		"title": "Sign in",
		"unknown_organization": "This organization does not exist or is not accepting sign-ins. Check the name."
	},
	"native_return": {
		"body": "Go back to the app to continue.",
		"title": "Go back to the app"
	},
	"node_role": {
		"editor": "Editor",
		"owner": "Owner",
		"viewer": "Viewer"
	},
	"search": {
		"popover": {
			"empty": {
				"description": {
					"all": "No files or folders match your search.",
					"folder": "No items found in this folder.",
					"shared": "No shared files match this name.",
					"trash": "No items in the trash match your search."
				},
				"title": "No results found"
			},
			"error": "The search could not be completed. Try again.",
			"input_label": "Search files and folders",
			"placeholder": "Search",
			"prompt": {
				"description": "Type a file or folder name to find what you’re looking for.",
				"title": "Search your files"
			},
			"results_count_one": "{{count}} result",
			"results_count_other": "{{count}} results",
			"scope": {
				"all": "All files",
				"chip": "in: “{{name}}”",
				"label": "Search scope",
				"remove_folder": "Search all files instead of just “{{name}}”",
				"shared": "Shared with me",
				"trash": "Bin"
			},
			"see_all": "All results",
			"widen": "Search all files"
		},
		"results_page": {
			"empty": {
				"description": "No results in {{scope}} for “{{q}}”. If someone sent you this link, you may see less than they did: search only shows what you have access to.",
				"title": "No results"
			},
			"error": {
				"description": "Search results could not be loaded.",
				"title": "Something went wrong"
			},
			"offline": {
				"description": "You appear to be offline, so results cannot be loaded. They will load again once the connection is back.",
				"title": "No connection"
			},
			"prompt": "Type something to search.",
			"scope": {
				"all": "all your files",
				"folder": "this folder",
				"shared": "what's shared with you"
			},
			"scope_label": "Scope",
			"title": "Search results"
		}
	},
	"share": {
		"access_empty": "Nobody else has access to this yet.",
		"add": {
			"message_label": "Message",
			"message_placeholder": "Message (optional)",
			"role_label": "Role of the people being added",
			"send": "Send",
			"share": "Share"
		},
		"cancel": "Cancel",
		"copy_link": {
			"copied": "Link copied",
			"failed": "The link could not be copied.",
			"menu": "Copy link"
		},
		"done": "Done",
		"drop_added": "Remove {{name}} from the list",
		"error": {
			"cannot_grant_to_self": "You cannot change your own access to this from here. Ask somebody else who can edit it.",
			"insufficient_role": "Only somebody who can edit this can manage who has access to it.",
			"last_owner": "This is the only owner. Give somebody else that role first.",
			"list_failed": "The access list could not be read. Try again.",
			"not_found": "This no longer exists, or is no longer reachable.",
			"owner_not_assignable": "The owner role cannot be given out: it belongs to whoever created the item.",
			"save_failed": "The access changes could not be saved. Your changes are still here: try again.",
			"sharing_version_conflict": "Somebody else changed the access while you were working. The list has been reloaded and your unsaved changes are gone: make them again and save."
		},
		"general": {
			"disabled_by_admin": "Turned off by the administrator.",
			"editor_capped": "The administrator only allows viewing.",
			"error": {
				"disabled": "The administrator doesn’t allow opening items to the whole organization with this role.",
				"failed": "Couldn’t change the access. Try again.",
				"inherited": "A folder containing it already opens it to the whole organization: you can’t close or lower it from here.",
				"personal_root": "The My files folder can’t be opened to the organization."
			},
			"heading": "General access",
			"inherited": "Opened through the folder {{name}}: here you can only give more.",
			"level_label": "Who can open it with the link",
			"load_failed": "Couldn’t load the general access.",
			"organization": "Organization",
			"organization_description": {
				"editor": "Anyone in this organization with the link can edit the item.",
				"viewer": "Anyone in this organization with the link can view the item."
			},
			"organization_fallback": "the organization",
			"restricted": "Restricted",
			"restricted_description": "Only people with access can use the link to open the item.",
			"role": {
				"editor": "Can edit",
				"viewer": "Can view"
			},
			"role_label": "What anyone opening the link can do"
		},
		"group_gone": "Group no longer available",
		"group_heading": "Groups",
		"group_inherited": "Group · Inherited from «{{name}}»",
		"group_label": "Group",
		"group_line_one": "Group · {{count}} member",
		"group_line_other": "Group · {{count}} members",
		"group_line_private_one": "Private group · {{count}} member",
		"group_line_private_other": "Private group · {{count}} members",
		"group_view_members": "View members",
		"inherited_from": "Inherited from “{{name}}”",
		"link": {
			"back": "Back to sharing",
			"create": "Create link",
			"create_title": "New public link",
			"created": "Link created.",
			"created_copied": "Link created and copied to the clipboard.",
			"creating": "Creating…",
			"expired_description": "You can create a new one, with a different address.",
			"expired_title": "Your link has expired",
			"expires_badge": "Expires on {{date}}",
			"expiry": {
				"label": "Expiry",
				"max_date": "Your organization allows an expiry up to {{date}}.",
				"toggle_label": "Set an expiry date",
				"tooltip": "After this date, the link will expire and can no longer be used."
			},
			"heading": "Public link",
			"load_failed": "The link could not be loaded.",
			"manage": "Manage",
			"none_description": "Anyone with the link will be able to view and download the item, even outside {{org}} and without signing in.",
			"others_gone": "an account no longer available",
			"others_one": "{{names}} has an active link on this item.",
			"others_other": "{{names}} have an active link on this item.",
			"own_blocked": "Suspended until an administrator turns links back on.",
			"own_description": "Anyone with this link can view and download",
			"password": {
				"change": "Change",
				"label": "Password",
				"set": "Password set",
				"toggle_label": "Protect with a password",
				"tooltip": "Anyone opening the link will need to enter this password to access the item."
			},
			"password_badge": "Password",
			"password_reminder": "The link doesn't include the password, so send it separately.",
			"refusal": {
				"already_exists": "You already have an active link on this item.",
				"expiry_out_of_range": "Your organization doesn't allow this date.",
				"not_allowed": "Your organization has turned off links. Ask an administrator.",
				"password_required": "Your organization requires a password on links."
			},
			"required": {
				"badge": "Required",
				"both": "Every public link needs a password and an expiry date. Set them below to create the link.",
				"expiry": "Every public link needs an expiry date. Pick one below to create the link.",
				"password": "Every public link needs a password. Set one below to create the link.",
				"title": "Required by your organization"
			},
			"revoke": "Revoke link",
			"revoke_confirm_title": "Revoke the link?",
			"revoked": "Link revoked.",
			"revoking": "Revoking…",
			"row": {
				"active_title": "You have an active public link",
				"cta": "Create a public link",
				"title": "Want to share it outside {{org}}?",
				"view": "View"
			},
			"settings": "Link settings",
			"unavailable_description": "Your organization doesn't allow them.",
			"unavailable_title": "Public links unavailable",
			"url_label": "Link address",
			"view_title": "Public link to “{{name}}”"
		},
		"menu": "Share",
		"notify": "Notify by email",
		"notify_failed": "Access saved. The email notification could not be sent.",
		"open": "Share",
		"pending": "To save",
		"people_heading": "People with access",
		"person_already": "Already has access",
		"person_empty": "Nobody found. Someone who was invited appears here only after they accept.",
		"person_gone": "Account no longer available",
		"person_label": "Person or group",
		"person_placeholder": "Add people or groups",
		"picker_people_heading": "People",
		"remove_access": "Remove access",
		"removed_downloads": "Anyone who already started a download can still finish it.",
		"request": {
			"back": "Back to the link",
			"create": "Create link",
			"description": "Anyone with the link can upload files to this folder without signing in, but can't see what's in it.",
			"links_off": "Links are turned off by your administrator",
			"load_failed": "Couldn't load the upload link.",
			"menu": "Upload link",
			"message_count": "{{length}} / {{max}}",
			"message_heading": "Message",
			"message_label": "Message for the sender (Optional)",
			"message_placeholder": "For example: upload this quarter's invoices here.",
			"others_one": "{{names}} has an active upload link on this folder.",
			"others_other": "{{names}} have an active upload link on this folder.",
			"required": {
				"both": "Every link needs a password and an expiry date. Set them below to create the link.",
				"expiry": "Every link needs an expiry date. Pick one below to create the link.",
				"password": "Every link needs a password. Set one below to create the link."
			},
			"revoke_confirm": "Whoever has the link won't be able to send you files anymore. Files that already arrived stay in the folder.",
			"settings": "Link settings",
			"title": "Upload link for “{{name}}”",
			"unavailable_description": "Your organization doesn't allow them.",
			"unavailable_title": "Upload links unavailable"
		},
		"role_actions": {
			"editor": "Creates, edits, uploads, renames and moves.",
			"viewer": "Views and downloads. Changes nothing."
		},
		"role_of": "Role of {{name}}",
		"save": "Save",
		"saved": "Access updated.",
		"saving": "Saving…",
		"title": "Access to “{{name}}”",
		"unsaved": "Unsaved changes"
	},
	"shared": {
		"empty": {
			"description": "When somebody shares a folder with you, you will find it here.",
			"title": "Nothing here yet"
		},
		"error": {
			"description": "Try again: nothing has changed.",
			"title": "We couldn’t load what is shared with you"
		},
		"offline": {
			"description": "You appear to be offline, so we cannot check what has been shared with you. We will try again as soon as the connection is back."
		},
		"sharer_unknown": "unknown",
		"title": "Shared with me"
	},
	"shortcuts": {
		"action": {
			"create_folder": "New folder",
			"create_upload": "Upload files",
			"create_upload_folder": "Upload folder",
			"folder_up": "Go to parent folder",
			"help": "Show keyboard shortcuts",
			"listing_extend": "Extend selection",
			"listing_move": "Move between items",
			"listing_open": "Open",
			"listing_paste": "Paste copied items",
			"listing_toggle": "Select or deselect item",
			"search_focus": "Search",
			"selection_all": "Select all",
			"selection_clear": "Clear selection",
			"selection_copy": "Copy selected items",
			"selection_delete": "Move to trash",
			"selection_download": "Download",
			"selection_rename": "Rename",
			"sidebar_toggle": "Show or hide sidebar"
		},
		"dialog": {
			"title": "Keyboard shortcuts"
		},
		"group": {
			"create": "Create",
			"general": "General",
			"listing": "List",
			"selection": "Selection"
		},
		"or": "or",
		"then": "then"
	},
	"trash": {
		"columns": {
			"deleted_at": "Deleted on",
			"deleted_by": "Deleted by",
			"name": "Name",
			"origin": "Original location",
			"size": "Size",
			"type": "Type"
		},
		"delete": {
			"action": "Delete permanently",
			"confirm": "Delete permanently",
			"confirm_description_one": "“{{name}}” will be permanently deleted and cannot be restored.",
			"confirm_description_other": "{{count}} items will be permanently deleted and cannot be restored.",
			"confirm_title": "Delete permanently?",
			"deleting": "Deleting…",
			"done_one": "Item permanently deleted.",
			"done_other": "{{count}} items permanently deleted.",
			"refusal": {
				"node_purged": "It is already being permanently deleted.",
				"purge_not_allowed": "Only {{name}} can delete it permanently.",
				"purge_not_allowed_others_one": "Only {{name}} can delete it permanently: it holds 1 item somebody else created.",
				"purge_not_allowed_others_other": "Only {{name}} can delete it permanently: it holds {{count}} items somebody else created.",
				"purge_not_allowed_unknown": "You cannot delete it permanently.",
				"state_conflict": "It is no longer in the bin.",
				"unknown": "It could not be permanently deleted."
			},
			"refusal_line": "“{{name}}”: {{reason}}",
			"refused_one": "One item was not deleted.",
			"refused_other": "{{count}} items were not deleted."
		},
		"deleted_by": {
			"unknown": "Deleted account"
		},
		"empty": {
			"button_label": "Empty bin",
			"confirm": "Empty bin",
			"confirm_description_one": "1 item ({{bytes}}) will be permanently deleted and cannot be restored.",
			"confirm_description_other": "{{count}} items ({{bytes}}) will be permanently deleted and cannot be restored.",
			"confirm_title": "Empty the bin?",
			"count_changed": "The number of items changed in the meantime. Check the updated figure and confirm again.",
			"done_one": "1 item permanently deleted.",
			"done_other": "{{count}} items permanently deleted.",
			"emptying": "Emptying…",
			"error": "The bin could not be emptied. Try again.",
			"kept_one": "1 item stays in the bin because it belongs to somebody else.",
			"kept_other": "{{count}} items stay in the bin because they belong to somebody else."
		},
		"empty_state": {
			"description": "Items moved to the bin will be deleted permanently after 30 days",
			"title": "The bin is empty"
		},
		"error": {
			"description": "The bin could not be loaded. Try again.",
			"title": "The bin could not be loaded"
		},
		"nav_label": "Bin",
		"offline": {
			"description": "You appear to be offline, so the bin cannot be reached. It will load again once the connection is back."
		},
		"origin": {
			"unavailable": "Not available"
		},
		"page_title": "Bin",
		"restore": {
			"action": "Restore",
			"done_one": "Item restored.",
			"done_other": "{{count}} items restored.",
			"name_conflict": {
				"description": "That name is already taken in the destination folder. You can restore it as “{{suggestedName}}”.",
				"rename_action": "Restore, renaming",
				"title": "Name already taken for “{{name}}”"
			},
			"origin_error": "The original folder could not be restored. Try again.",
			"origin_trashed": {
				"choose_destination_action": "Choose where to restore",
				"description": "The folder “{{parentName}}” it came from is also in the bin.",
				"restore_origin_action": "Restore the original folder",
				"title": "The folder “{{name}}” came from is in the bin",
				"unnamed_folder": "this folder"
			},
			"picker": {
				"back": "Back",
				"confirm": "Restore here",
				"title": "Choose where to restore"
			},
			"purged_one": "1 item had already been permanently deleted by somebody else.",
			"purged_other": "{{count}} items had already been permanently deleted by somebody else.",
			"refusal": {
				"insufficient_role": "You can no longer restore this item.",
				"name_taken": "The original folder already holds an item with this name.",
				"parent_trashed": "The original folder is in the bin.",
				"state_conflict": "It is no longer in the bin.",
				"unknown": "It could not be restored."
			},
			"refusal_line": "“{{name}}”: {{reason}}",
			"refused_one": "One item was not restored.",
			"refused_other": "{{count}} items were not restored.",
			"restoring": "Restoring…"
		},
		"retention_banner": "Items in the bin will be deleted permanently after 30 days"
	}
}
